import React from 'react';

const FullLogo = () => {
  return (
    <img
      src="https://d2oi1rqwb0pj00.cloudfront.net/lesan/nasio/topnav-logo-desktop.png"
      alt="nas.io logo"
      width="162"
      height="32"
    />
  );
};

export default FullLogo;
